import { Tooltip as ChakraTooltip, type TooltipProps } from '@chakra-ui/react';

/**
 * Tooltip primitive. Styling (Midnight bg, radius, type) comes from the theme
 * recipe. For the cursor-following "Copied!" feedback bubble, use the dedicated
 * `CopyTooltip` (re-exported from `src/ui/patterns`), which is a distinct
 * interaction, not a hover tooltip.
 */
export const Tooltip = ({ hasArrow = false, openDelay = 200, ...rest }: TooltipProps) => (
	<ChakraTooltip hasArrow={hasArrow} openDelay={openDelay} {...rest} />
);

export type { TooltipProps };
export default Tooltip;
